export enum TrackingCategory {
  FLYOUT = 'Fly-Out',
  CONFIGURE = 'Configure',
  ENHANCED_ECOMMERCE = 'Enchanced Ecommerce',
}

export enum TrackingAction {
  FLYOUT_VIEWED = 'Fly-Out Viewed',
  FLYOUT_CLOSED = 'Fly-Out Closed',
  QUANTITY_CLICKED = 'Quantity Clicked',
  ERROR_DISPLAYED = 'Error Displayed',
  PRODUCT_ADDED = 'Product Added',
  PRODUCT_VIEWED = 'Product Viewed',
  PRODUCT_LIST_VIEWED = 'Product List Viewed',
  EXPERIMENT_CLICKED = 'Experiment Clicked',
}

export enum TrackingLabel {
  SIZE_CHART_OPEN = 'Size Chart Fly-Out',
  SIZE_CHART_CLOSE = 'Size Chart Fly-Out Closed',
  RELATED_PRODUCT_SIZE_CHART_OPEN = 'Matching Chart Fly-out',
  RELATED_PRODUCT_SIZE_CHART_CLOSE = 'Matching Size Chart Fly-Out Closed',
  RELATED_PRODUCT_ADDED = 'Item Added',
  RELATED_PRODUCT_REMOVED = 'Item Removed',
  RELATED_PRODUCT_UNDO = 'Undo',
  RELATED_PRODUCTS_CAROUSEL = 'QSP Carousel',
  ADD_TO_CART_INVALID_QUANTITY_ERROR = 'Invalid Quantity for Add to Cart',
  ADD_TO_CART_SUCCESS = 'Product Added',
  QSP_PRODUCT_VIEWED = 'Quantity Selection page view',
}
